import React, { Component } from "react";
import { withFormsy } from "formsy-react";
import {
  FormGroup,
  FormFeedback,
  Label,
  Input,
  FormText,
  Card,
  CardBody
} from "reactstrap";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";

class LocationSelect extends Component {
  state = {
    address: "",
    errorMessage: "",
    lat: null,
    lng: null,
    isGeocoding: false
  };

  handleChange = address => {
    this.setState({ address });
  };

  handleSelect = address => {
    this.setState({
      isGeocoding: true,
      address
    });
    geocodeByAddress(address)
      .then(results => {
       
        return getLatLng(results[0]);
      })
      .then(({ lat, lng }) => {
        this.setState(
          {
            lat,
            lng,
            isGeocoding: false
          },
          () => {
            const { lat, lng, address } = this.state;
            const addressObject = {
              lat,
              lng,
              address
            };
            if (this.props.onChange) {
              this.props.onChange(addressObject);
            }
            this.props.setValue(addressObject);
          }
        );
      
      })
      .catch(error => {
        this.setState({ isGeocoding: false });
        console.error("Error", error);
      });
  };

  handleError = (status, clearSuggestions) => {
    // eslint-disable-line no-console
    this.setState({ errorMessage: status }, () => {
      clearSuggestions();
    });
  };

  render() {
    const { address, errorMessage } = this.state;
    const {
      name,
      label,
      validating,
      className,
      disabled,
      showRequired,
      showError,
      placeholder,
      isPristine,
      infoText,
      hasValue,
      isRequired,
      subtitle
    } = this.props;

    const hasError =
      !isPristine() && (showError() || (isRequired() && !hasValue()));
    return (
      <PlacesAutocomplete
        value={address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        onError={this.handleError}
        shouldFetchSuggestions={address.length > 4}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <FormGroup className={className}>
            {!!label && (
              <Label className={isRequired() ? "required" : ""} htmlFor={name}>
                {label}
              </Label>
            )}
            {subtitle && (
              <label
                style={{
                  color: "blue",
                  fontStyle: "italic",
                  fontSize: "10px"
                }}
              >
                {subtitle}
              </label>
            )}
            <Input
              invalid={hasError}
              disabled={validating ? true : false || disabled}
              id={name}
              {...getInputProps({
                placeholder: placeholder || "Search Places ...",
                className: "location-search-input"
              })}
            />
            {!!suggestions.length && (
              <Card className="autocomplete-dropdown-container">
                <CardBody className="p-0">
                  {loading && <div>Loading...</div>}
                  {suggestions.map(suggestion => {
                    const className = suggestion.active
                      ? "suggestion-item--active p-1"
                      : "suggestion-item p-1";
                    const style = suggestion.active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style
                        })}
                      >
                        <strong>
                          {suggestion.formattedSuggestion.mainText}
                        </strong>{" "}
                        <span>
                          {suggestion.formattedSuggestion.secondaryText}
                        </span>
                      </div>
                    );
                  })}
                </CardBody>
              </Card>
            )}

            {infoText ? <FormText>{infoText}</FormText> : ""}
            {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
            {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
          </FormGroup>
        )}
      </PlacesAutocomplete>
    );
  }
}

const LocationDropdown = withFormsy(LocationSelect);

export { LocationDropdown as LocationSelect };
